export const particleOption = {
  particles: {
    number: {
      value: 40,
      density: {
        enable: true,
        value_area: 4000,
      },
    },
    color: {
      value: '#ffffff',
    },
    opacity: {
      value: 0.5,
      random: false,
      anim: {
        enable: false,
        speed: 1,
        opacity_min: 0.1,
        sync: false,
      },
    },
    size: {
      value: 10,
      random: true,
      anim: {
        enable: false,
        speed: 500,
        size_min: 0.1,
        sync: false,
      },
    },
    line_linked: {
      enable: true,
      distance: 300,
      color: '#112d31',
      opacity: 0.4,
      width: 2,
    },
    move: {
      enable: true,
      speed: 12,
      direction: 'none',
      random: false,
      straight: false,
      out_mode: 'out',
      bounce: false,
      attract: {
        enable: false,
        rotateX: 600,
        rotateY: 1200,
      },
    },
  },
  interactivity: {
    detect_on: 'canvas',
    events: {
      onhover: {
        enable: true,
        mode: 'repulse',
      },
      resize: true,
    },
  },
  retina_detect: true,
};



// WEBPACK FOOTER //
// ./src/particle.js